import { entityRouteRef } from '@backstage/plugin-catalog-react';
import { useRouteRefParams } from '@backstage/frontend-plugin-api';
import { CloudResourcesContextProvider, PageType } from '../Providers';
import { RuleResourcesTable } from '../EntityPages';

export const RuleResourcesTab = () => {
  const { name } = useRouteRefParams(entityRouteRef);

  return (
    <CloudResourcesContextProvider pageType={PageType.RULE} entityName={name}>
      <RuleResourcesTable />
    </CloudResourcesContextProvider>
  );
};
